import { QueryClient } from '@tanstack/react-query';

// Create a client
// moved to a separate file to avoid circular dependencies, which broke the test suite
export const queryClient = new QueryClient();
